import dashboardHtml from '../pages/dashboard/dashboard.html?raw';
import productDetailHtml from '../pages/product/product-detail.html?raw';
import articleDetailHtml from '../pages/article/article-detail.html?raw';
import blogCategoryHtml from '../pages/article/blog-categories.html?raw';
import blogCategoryDetailHtml from '../pages/article/blog-category-detail.html?raw';
import productCategoriesHtml from '../pages/product/product-categories.html?raw';
import productCategoryDetailHtml from '../pages/product/product-category-detail.html?raw';

interface Route {
  html: string;
  script: () => Promise<any>;
}

const routes: Record<string, Route> = {
  '/': {
    html: dashboardHtml,
    script: () => import('../pages/dashboard/dashboard'),
  },

  '/product-detail': {
    html: productDetailHtml,
    script: () => import('../pages/product/product-detail'),
  },

  '/product-categories': {
    html: productCategoriesHtml,
    script: () => import('../pages/product/product-categories'),
  },

  '/product-category-detail': {
    html: productCategoryDetailHtml,
    script: () => import('../pages/product/product-category-detail'),
  },

  '/blog-categories': {
    html: blogCategoryHtml,
    script: () => import('../pages/article/blog-categories'),
  },

  '/blog-category-detail': {
    html: blogCategoryDetailHtml,
    script: () => import('../pages/article/blog-category-detail'),
  },

  '/article-detail': {
    html: articleDetailHtml,
    script: () => import('../pages/article/article-detail'),
  },
};

function getHashPath(): string {
  const hash = window.location.hash;

  if (!hash || hash === '#') {
    return '/';
  }

  return hash
    .replace(/^#/, '')
    .split('?')[0]
    .replace(/\/+$/, '') || '/';
}

export async function navigate(
  path: string,
  pushHistory = true
) {
  const rawPath =
    path
      .replace(/^#/, '')
      .split('?')[0]
      .replace(/\/+$/, '') || '/';

  console.log('[Router] path:', rawPath);

  // ==========================
  // XỬ LÝ DYNAMIC ROUTES
  // ==========================
  let matchedRouteKey = rawPath;

  if (rawPath.startsWith('/blog-category/')) {
    matchedRouteKey = '/blog-category-detail';
  } else if (rawPath.startsWith('/product-category/')) {
    matchedRouteKey = '/product-category-detail';
  } else if (rawPath.startsWith('/product-detail/')) {
    // Khớp cho trang chi tiết sản phẩm có kèm ID (VD: /product-detail/f5bbdf29-...)
    matchedRouteKey = '/product-detail';
  } else if (rawPath.startsWith('/article-detail/')) {
    matchedRouteKey = '/article-detail';
  }

  const route = routes[matchedRouteKey];

  if (!route) {
    console.error('[Router] Route not found:', rawPath);

    const content = document.querySelector('#content');

    if (content) {
      content.innerHTML = `
        <div class="page-error">
          <h2>404 - Page Not Found</h2>
          <p>${rawPath}</p>
        </div>
      `;
    }

    return;
  }

  const content = document.querySelector('#content');

  if (!content) {
    console.error('[Router] #content not found');
    return;
  }

  try {
    console.log('[Router] Loading HTML:', matchedRouteKey);

    // ==========================
    // LOAD HTML
    // ==========================
    content.innerHTML = route.html;

    console.log('[Router] HTML loaded');

    // ==========================
    // LOAD PAGE JS
    // ==========================
    console.log('[Router] Loading JS');

    const module = await route.script();

    console.log('[Router] JS loaded:', module);

    // ==========================
    // INIT PAGE
    // ==========================
    if (typeof module.init === 'function') {
      await module.init();
    }

    console.log('[Router] Page initialized');

    // ==========================
    // HASH HISTORY
    // ==========================
    if (pushHistory) {
      const currentHash = window.location.hash;

      if (currentHash !== `#${rawPath}`) {
        window.history.pushState(
          {},
          '',
          `#${rawPath}`
        );
      }
    }

  } catch (error) {
    console.error('[Router] Navigation error:', error);

    content.innerHTML = `
      <div class="page-error">
        <h2>Không thể tải trang</h2>
        <pre>${error}</pre>
      </div>
    `;
  }
}

export function startRouter() {
  // Browser back / forward
  window.addEventListener('popstate', () => {
    console.log(
      '[Router] popstate:',
      getHashPath()
    );

    navigate(getHashPath(), false);
  });

  // Hash thay đổi
  window.addEventListener('hashchange', () => {
    console.log(
      '[Router] hashchange:',
      getHashPath()
    );

    navigate(getHashPath(), false);
  });
}

export function getCurrentPath(): string {
  return getHashPath();
}